import { Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Injectable({providedIn: 'root'})
export class TenantService {

  private readonly _logoutIfNoTenant$ = new ReplaySubject<string>(1);
  readonly logoutIfNoTenant$ = this._logoutIfNoTenant$.asObservable();

  logoutIfNoTenant(urlTenant: string): void {
    this._logoutIfNoTenant$.next(urlTenant);
  }
}
